<div class="box select-box select-clinic-box">
  <pp-generic-form-page
    [formType]="formTypes.ScreeningForms">
  </pp-generic-form-page>
</div>
